import { render, staticRenderFns } from "./ImageCollapserExpander.vue?vue&type=template&id=0615fcfc&"
import script from "./ImageCollapserExpander.vue?vue&type=script&lang=js&"
export * from "./ImageCollapserExpander.vue?vue&type=script&lang=js&"
import style0 from "./ImageCollapserExpander.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports